export default "__VITE_ASSET__cB__Sizi__"